import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import SelectInput from 'components/forms/SelectInput';

import { moment } from 'util/dateTime';

export default class HourSelectInput extends PureComponent {
  static propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    short: PropTypes.bool,
  };

  static defaultProps = {
    min: 0,
    max: 23,
    short: false,
  };

  options = [...Array(24).keys()].map(k => ({
    value: k,
    label: moment(k, 'H').format(this.props.short ? 'hh a' : 'hh:mm a'),
  }));

  hourOptions =
    this.props.min > HourSelectInput.defaultProps.min ||
    this.props.max < HourSelectInput.defaultProps.max
      ? this.options.filter(
          option =>
            option.value >= this.props.min && option.value <= this.props.max
        )
      : this.options;

  render() {
    return (
      <SelectInput
        clearable={false}
        {...this.props}
        options={this.hourOptions}
      />
    );
  }
}
